// components/ui/PageTitle.js — h1 with consistent typography.
// No decoration. The page is its own header; no full-bleed hero needed.
import React from 'react';

export default function PageTitle({ children, className = '' }) {
  return (
    <h1 className={`text-3xl font-bold text-ink tracking-tight ${className}`}>
      {children}
    </h1>
  );
}
